<template>
    <router-view language="language"></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
html,body { height: 100%; margin: 0px; padding: 0px; }
body {
  margin: 0;
  font-size: 2rem;
  font-family: -apple-system, BlinkMacSystemFont,
               'avenir next', avenir,
               helvetica, 'helvetica neue',
               Ubuntu,
               'segoe ui', arial,
               sans-serif;
}
.page {
  text-align: center;
  code {
    background-color: #f0f0f0;
    padding: 3px 5px;
    border-radius: 2px;
  }
}
.el-menu-item {
  background-color: #324057;
  color: #fff;
}

@import "./style/main";

</style>


// WEBPACK FOOTER //
// App.vue?0b97cec0